module.exports = __webpack_public_path__ + "img/DE00444.2b435f29.png";